// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/customerprofile.css
// module id = 813
// module chunks = 1